import { UIIcon } from '../config/icons';
import { ABFilterBar } from '../lib/ab/filter-bar';
import { CReviewProducerView, cReviewsProducerView } from '../lib/mdl/c-event-admin';
import { the_producer } from '../lib/me/producer';
import { UIDataAdapter } from '../lib/ui/component/adapter';
import { UIList } from '../lib/ui/component/list';
import { $el } from '../lib/ui/elements';
import { UIScreen } from '../lib/ui/screen';
import { UIViewSpec } from '../lib/ui/view';
import { $fn } from '../lib/y/fn';
import { $i18n, yInterpolate } from '../lib/y/i18n';
import { $time } from '../lib/y/time';
import { YId } from '../lib/y/types';

export function producerMakeReviewDiv(r: CReviewProducerView) {
    return $el.DIV('tl-producer-review', [
        $el.DIV('r-top', [
            $el.ICON(r.rating == 'down' ? UIIcon.THUMBS_DOWN | UIIcon.WEIGHT_SOLID : UIIcon.THUMBS_UP | UIIcon.WEIGHT_SOLID),
            $el.DIV('r-texts', [
                $el.B(r.event_name),
                $el.DIV('r-date', r.user_name + '\u00a0\u00b7\u00a0' + $time(r.session_time).format('EEE d MMM yyyy HH:mm'))
            ])
        ]),
        $el.P('text', r.text),
    ]);
}

export class ProducerReviewsScreen extends UIScreen {
    constructor() {
        super();
    }

    protected override async fillContent(content: UIViewSpec) {
        const all_reviews = await cReviewsProducerView(the_producer!.id);
        all_reviews.sort((a, b) => b.created_at.localeCompare(a.created_at));

        const grid = new UIDataAdapter(producerMakeReviewDiv);

        const doSearch = () => {
            let reviews = all_reviews;
            if(filters.value.event) {
                const event = filters.value.event;
                reviews = reviews.filter(r => r.event_id == event);
                title.textContent = yInterpolate($i18n.pr.reviews_title, all_events.get(event) || '');
            } else {
                title.textContent = yInterpolate($i18n.pr.reviews_title, $i18n.pr.filter_events_all);
            }

            reviews = filter_bar.search_input!.filterArray(reviews, (r, w) => {
                if(r.event_name.toLowerCase().includes(w)) return true;
                if(r.user_name.toLowerCase().includes(w)) return true;
                if(r.text.toLowerCase().includes(w)) return true;
                return false;
            });

            //     const pdf_link = '/docs/reviews?token='+$tl.the_login!.alt_token;

            //     const event = event_select.value;
            //     if(event) {
            //         reviews = reviews.filter(r => r.event == event);
            //         pdf_link += '&event='+event;
            //     }

            // const up = 0;
            // const total = 0;

            //     for(const e of all_events) {
            //         if(event && e.model.id != event) continue;
            //         up += e.model.ratings_up;
            //         total += e.model.ratings_up + e.model.ratings_down;
            //     }

            //     pdf_download.link = pdf_link;


            //     this.object_count!.count = reviews.length;

            //     positive.textContent = total ? ('\u00a0\u00a0(' + (100*up/total).toFixed(0) + '% 👍)') : '';
            //     source.data = reviews;

            grid.data = reviews;
        }

        const filter_bar = new ABFilterBar({ on_search: doSearch, on_filter: doSearch });
        const filters = filter_bar.filters;

        const all_events = new Map<YId, string>();
        for(const review of all_reviews) {
            all_events.set(review.event_id, review.event_name);
        }

        filters.addSelect('event', $i18n.pr.filter_events, Array.from(all_events).map(e => ({ key: e[0], name: e[1] })).filter(e => e.name).sort((a, b) => $fn.ICOMPARE(a.name, b.name)), $i18n.pr.filter_events_all);

        const title = $el.P('screen-title', yInterpolate($i18n.pr.reviews_title, $i18n.pr.filter_events_all))

        content.ui_add($el.DIV('ui-section', $el.DIV('tl-new-list-block', [
            title,
            $el.P('screen-mobile-title', $i18n.pr.reviews_mobile_title),
            filter_bar,
            new UIList(grid, { classes: 'r-grid', progressive: true })
        ])));

        doSearch();
    }
}
